import React from "react";
import Header from "../../components/Header";
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import app from 'firebase/compat/app';
import { getDatabase, ref, child, get, onValue, update, set, push, remove } from "firebase/database";
import CodeMirror from "react-codemirror";
import "./Coding.css";
import "./dracula.css";
import VideoChat from "../../components/VideoChat";
import Eval from "../../components/Eval";
import { RemoveScroll } from "react-remove-scroll";
import Dropdown from "../../components/Dropdown";
import ReactGA from "react-ga";
import { Resizable } from "re-resizable";
import Hotkeys from 'react-hot-keys';
import History from '../../components/History';
import Card from "../../components/Card";
import { IconContext } from "react-icons";
import { CiLogin, CiLogout } from "react-icons/ci";

require("codemirror/lib/codemirror.css");
require("codemirror/mode/javascript/javascript");
require("codemirror/mode/ruby/ruby");
require("codemirror/mode/python/python");
require("codemirror/mode/swift/swift");
require("codemirror/mode/clike/clike");
require("codemirror/mode/go/go");
require("codemirror/mode/php/php");
require("codemirror/mode/r/r");
require("codemirror/mode/clike/clike");
require("codemirror/addon/display/placeholder");
require("codemirror/addon/edit/matchbrackets");
require("codemirror/addon/edit/matchtags");
require("codemirror/addon/edit/closebrackets");
require("codemirror/addon/edit/closetag");

function initializeAnalytics() {
  ReactGA.initialize("UA-154969560-1");
  ReactGA.pageview("/Interview");
}

export default class Interview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      code: "Loading...",
      loading: false,
      mode: "python",
      language_id: 71,
      language: [
        {
          id: 0,
          language_id: 63,
          title: " JS",
          mode: "javascript",
          fa_icon: "FaJsSquare",
          selected: false,
          key: "language",
        },
        {
          id: 1,
          language_id: 71,
          title: " Python",
          mode: "python",
          fa_icon: "FaPython",
          selected: false,
          key: "language",
        },
        {
          id: 2,
          language_id: 72,
          title: " Ruby",
          mode: "ruby",
          fa_icon: "FaGem",
          selected: false,
          key: "language",
        },
        {
          id: 3,
          language_id: 83,
          title: " Swift",
          mode: "swift",
          fa_icon: "FaSwift",
          selected: false,
          key: "language",
        },
        {
          id: 4,
          language_id: 62,
          title: " Java",
          mode: "text/x-java",
          fa_icon: "FaJava",
          selected: false,
          key: "language",
        },
        {
          id: 5,
          language_id: 60,
          title: " Go",
          mode: "text/x-go",
          fa_icon: "FaGoogle",
          selected: false,
          key: "language",
        },
        {
          id: 6,
          language_id: 78,
          title: " Kotlin",
          mode: "text/x-kotlin",
          fa_icon: "FaAndroid",
          selected: false,
          key: "language",
        },
        {
          id: 7,
          language_id: 68,
          title: " PHP",
          mode: "application/x-httpd-php",
          fa_icon: "FaPhp",
          selected: false,
          key: "language",
        },
        {
          id: 8,
          language_id: 80,
          title: " R",
          mode: "text/x-rsrc",
          fa_icon: "FaRProject",
          selected: false,
          key: "language",
        },
        {
          id: 9,
          language_id: 81,
          title: " Scala",
          mode: "text/x-scala",
          fa_icon: "FaBars",
          selected: false,
          key: "language",
        },
        {
          id: 10,
          language_id: 54,
          title: " C++",
          mode: "text/x-c++src",
          fa_icon: "SiCplusplus",
          selected: false,
          key: "language",
        },
        {
          id: 11,
          language_id: 43,
          title: " plntxt",
          mode: "text/plain",
          fa_icon: "BsCursorText",
          selected: false,
          key: "language",
        },
      ],
      currlang: " Python",
      cursorPosition: {
        line: 0,
        ch: 0,
      },
      witeboard: null,
      sessionid: null,
      darkMode: this.props.darkMode,
      evalExtend: false,
      timerExtend: true,
      whiteboardExtend: false,
      openAiToggle: false,
      borderToggle: true,
      completionToggle: false,
      flanT5Toggle: false,
      anthropicToggle: false,
      PaLMToggle: false,
      token: null,
      evalOutput: null,
      compileOutput: null,
      memory: null,
      time: null,
      history: {},
      output: null,
      output2: "",
      output3: "",
      modelOutput: [],
      usage: null,
      cardCreated: null,
      hotkeys: null,
      cards: [],
      cardsOpenAI: [],
      cardsHF: [],
      cardsPaLM: [],
      cardsAnthropic: [],
      lastQueryTime: null, // last time the OpenAI query was made
      login: false,
    };
    this.toggleLanguage = this.toggleLanguage.bind(this);
    this.toggleExtend = this.toggleExtend.bind(this);
    this.toggleTimer = this.toggleTimer.bind(this);
    this.toggleWhiteboard = this.toggleWhiteboard.bind(this);
    this.toggleCompletion = this.toggleCompletion.bind(this);
    this.whiteboardRender = this.whiteboardRender.bind(this);
    this.loginRender = this.loginRender.bind(this);
    this.toolTipRender = this.toolTipRender.bind(this);
    this.runCode = this.runCode.bind(this);
    this.useOpenAI = this.useOpenAI.bind(this);
    this.useHuggingFace = this.useHuggingFace.bind(this);
    this.useAnthropic = this.useAnthropic.bind(this);
    this.usePaLM = this.usePaLM.bind(this);
    this.toggleAnthropic = this.toggleAnthropic.bind(this);
    this.togglePaLM = this.togglePaLM.bind(this);
    this.toggleFlanT5 = this.toggleFlanT5.bind(this);
    this.mapCards = this.mapCards.bind(this);
    this.closeCard = this.closeCard.bind(this);
    this.copyCard = this.copyCard.bind(this);
    this.poweredBy = this.poweredBy.bind(this);
    this.logout = this.logout.bind(this);
    this.login = this.login.bind(this);
    this.acceptSuggestion = this.acceptSuggestion.bind(this);
    this.denySuggestion = this.denySuggestion.bind(this);
    this.auth = app.auth();
  }

  componentDidMount = () => {
    const { params } = this.props.match;
    let self = this;

    const isDevelopment = process.env.REACT_APP_IS_DEVELOPMENT === 'true';
    this.setState({ isDevelopment });

    // Utility function to simplify getting session storage items as booleans
    const getBooleanFromSession = (key) => sessionStorage.getItem(key) === 'true';

    if (sessionStorage.getItem("currlang")) {
      const key = sessionStorage.getItem("key");
      const mode = sessionStorage.getItem("mode");
      const language_id = sessionStorage.getItem("language_id");
      const currlang = sessionStorage.getItem("currlang");
      self.setState({ key, mode, language_id, currlang });
    }

    const historyFromLocal = localStorage.getItem("history");
    if (historyFromLocal) {
      this.setState({ history: JSON.parse(historyFromLocal) });
    }

    const borderToggleFromSession = sessionStorage.getItem("borderToggle");
    if (borderToggleFromSession) {
      this.setState({ borderToggle: JSON.parse(borderToggleFromSession) });
    }

    const whiteboardExtendFromSession = sessionStorage.getItem("whiteboardExtend");
    if (whiteboardExtendFromSession) {
      this.setState({ whiteboardExtend: getBooleanFromSession("whiteboardExtend") });
    }

    // For toggles that are booleans in session storage
    const toggles = ["flanT5Toggle", "anthropicToggle", "PaLMToggle", "completionToggle"];
    toggles.forEach(toggle => {
      const value = sessionStorage.getItem(toggle);
      if (value) {
        self.setState({ [toggle]: getBooleanFromSession(toggle) });
      }
    });

    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        // eslint-disable-next-line 
        const uid = user.uid;
        if (sessionStorage.getItem("openAiToggle") === "false") {
          this.setState({
            openAiToggle: false
          })
        } else if (sessionStorage.getItem("openAiToggle") === "true") {
          this.setState({
            openAiToggle: true
          })
        }

        this.setState({
          user: user,
          login: true,
          uid: uid
        })
        // ...
      } else {
        // User is signed out
        // ...
        this.setState({
          login: false,
        })
      }
    });

    setTimeout(() => {
      const dbRef = ref(getDatabase());
      get(child(dbRef, `interviews/${this.props.uid}/${params.sessionid}`)).then((snapshot) => {
        if (snapshot.exists()) {
          this.setState({
            code: snapshot.val().content,
            createdon: snapshot.val().createdon,
            witeboard: "https://witeboard.com/" + params.sessionid,
            sessionid: params.sessionid,
          });
        }
      });

      onValue(child(dbRef, `interviews/${this.props.uid}/${params.sessionid}`), (snapshot) => {
        self.setState({
          code: snapshot.val().content,
          evalOutputDB: snapshot.val().evalOutput,
        });
      });
    }, 750);
  };

  handleKeyEvent(action, keyName) {
    this.setState({
      hotkeys: `${action} ${keyName}`,
    });
  }

  onKeyUp(keyName) {
    this.handleKeyEvent('onKeyUp', keyName);
  }

  onKeyDown(keyName) {
    this.handleKeyEvent('onKeyDown', keyName);
    this.runCode();
  }

  aiCompletion = () => {
    // Determine environment and return the corresponding URL
    const baseURL = (process.env.NODE_ENV === 'production') ?
      'https://interview-sandbox-production.up.railway.app' :
      'http://localhost:8000';
    const { currlang, sessionid, code, suffix } = this.state;

    let evntSrtm = new EventSource(`${baseURL}/completion?language=${currlang}&sessionid=${sessionid}&code=${encodeURIComponent(code)}&suffix=${suffix}/`);

    evntSrtm.addEventListener("message", (event) => {
      if (event.data === '[DONE]') {
        handleDoneEvent();
      } else if (event.data[0] === "d") {
        handleDStartEvent(event);
      } else {
        handleOtherEvent(event);
      }
    });

    const handleDoneEvent = () => {
      evntSrtm.close();
      this.setState({
        charCoords: this.codemirror.getCodeMirror().charCoords(this.state.cursorPosition)
      });
      const { line, ch } = this.state.cursorPosition;
      this.codemirror.getCodeMirror().doc.setCursor(line, ch);
      this.codemirror.getCodeMirror().doc.markText(this.state.cursorPosition, { line, ch: ch + this.state.codeSuggestion.length }, { className: "styled-background" });
    };

    const handleDStartEvent = (event) => {
      let spliced1stEvent = JSON.parse(event.data.substring(6));
      let splicedEvent2 = this.state.mode === "text/plain" ?
        spliced1stEvent.choices[0].text :
        spliced1stEvent.choices[0].delta.content;

      let newOutput = this.state.codeSuggestion + splicedEvent2;
      this.setState({
        codeSuggestion: newOutput
      });
    };

    const handleOtherEvent = (event) => {
      let newEvent = JSON.parse(event.data);
      if (newEvent.text === undefined) return;

      // Set the complete suggestion in state
      this.setState({ codeSuggestion: newEvent.text }, () => {
        console.log("this.state.codeSuggestion after update: ", this.state.codeSuggestion);
      });

      // Remove previous suggestion mark (if any)
      const cm = this.codemirror.getCodeMirror();
      cm.getAllMarks().forEach(marker => marker.clear());
      console.log("cm: ", cm.getAllMarks());

      // Get current cursor position
      const { line, ch } = this.state.cursorPosition;

      // Clear any existing suggestion text
      const currentText = cm.getRange(
        { line, ch },
        { line, ch: ch + (this.state.codeSuggestion ? this.state.codeSuggestion.length : 0) }
      );
      if (currentText) {
        cm.replaceRange("", { line, ch }, { line, ch: ch + currentText.length });
      }

      // Insert the complete text
      cm.replaceRange(newEvent.text, { line, ch });

      // Mark the entire suggestion
      cm.markText(
        { line, ch },
        { line, ch: ch + newEvent.text.length },
        { className: "styled-background" }
      );
    };


    evntSrtm.addEventListener("error", (error) => {
      console.log(error);
    });
  }

  useHuggingFace = async () => {
    const baseURL = process.env.NODE_ENV === "development"
      ? "http://localhost:8000"
      : "https://interview-sandbox-production.up.railway.app";

    const codeInput = this.state.code;
    const hfURL = `${baseURL}/huggingface?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`;

    const response = await fetch(hfURL, { method: "GET" });
    const data = await response.text();

    this.processData(data);
    this.startCardRender();
  }


  processData = (data) => {
    const newCardAdded = [{
      output: data.split(""),
      time: new Date().toLocaleString(),
      model: "hf"
    }];
    this.setState({ cardsHF: newCardAdded });
  }

  startCardRender = () => {
    const cardRender = setInterval(() => {
      const cardsHF = this.state.cardsHF;
      if (!cardsHF[0] || cardsHF[0].output.length === 0) {
        clearInterval(cardRender);
        this.setState({ cardsHF: [] });
        return;
      }
      this.updateCards();
    }, 10);
  }

  updateCards = () => {
    const cards = this.state.cards;
    const cardsHF = this.state.cardsHF;
    const code = cardsHF[0].output;
    const time = cardsHF[0].time;

    if (!cards[0] || cards[0].time !== time) {
      cards.unshift({ output: [], time: undefined, model: undefined });
    }

    const outputSnippet = code.slice(0, 1);
    const newCards = [{
      output: (cards[0].output || []).concat(outputSnippet),
      time: time,
      model: "hf"
    }, ...cards.slice(1)];

    const newCards2 = [{
      output: code.slice(1),
      time: time,
      model: "hf"
    }, ...cardsHF.slice(1)];

    this.setState({
      cards: newCards,
      cardsHF: newCards2
    });
  }

  usePaLM = async () => {
    const baseURL = process.env.NODE_ENV === "development"
      ? "http://localhost:8000"
      : "https://interview-sandbox-production.up.railway.app";
    const codeInput = this.state.code;

    const palmURL = `${baseURL}/palm?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`;

    const handleResponse = async (response) => {
      const data = await response.text();
      const newCardAdded = [{
        "output": data.split(""),
        "time": new Date().toLocaleString(),
        "model": "Google PaLM"
      }];
      this.setState({ cardsPaLM: newCardAdded });
    }

    const fetchPaLM = async () => {
      const response = await fetch(palmURL, { method: "GET" });
      await handleResponse(response);
    }

    const renderCard = () => {
      if (typeof (this.state.cardsPaLM[0]) === 'undefined') {
        return;
      }
      else if (this.state.cardsPaLM[0].output.length === 0) {
        clearInterval(cardRender, 1000);
        this.setState({ cardsPaLM: [] });
      }
      else if (this.state.cardsPaLM[0].output.length > 0) {
        if (!this.state.cards[0]) {
          this.state.cards.unshift({ "output": [], "time": undefined, "model": undefined });
        }
        if (this.state.cards[0].time !== this.state.cardsPaLM[0].time && this.state.cards[0].time !== undefined) {
          this.state.cards.unshift({ "output": [], "time": undefined, "model": undefined });
        }
        const code = this.state.cardsPaLM[0].output;
        const time = this.state.cardsPaLM[0].time;
        const cardsPaLMOutput = code.slice(1,);
        const outputSnippet = code.slice(0, 1);
        const newCards = [{ "output": this.state.cards[0].output.concat(outputSnippet), "time": time, "model": "Google PaLM" }, ...this.state.cards.slice(1,)];
        const newCards2 = [{ "output": cardsPaLMOutput, "time": time, "model": "Google PaLM" }, ...this.state.cardsPaLM.slice(1,)];
        this.setState({
          cards: newCards,
          cardsPaLM: newCards2
        });
      }
    }

    await fetchPaLM();

    const cardRender = setInterval(renderCard, 1);
  }

  useAnthropic = async () => {
    const { code, currlang, sessionid } = this.state;

    const baseURL = process.env.NODE_ENV === "development"
      ? `http://localhost:8000/anthropic?language=${currlang}&sessionid=${sessionid}&code=${encodeURIComponent(code)}`
      : `https://interview-sandbox-production.up.railway.app/anthropic?language=${currlang}&sessionid=${sessionid}&code=${encodeURIComponent(code)}`;

    const eventStrm = new EventSource(`${baseURL}/`);

    const createCard = (output = [], time, model = "anthropic") => {
      return { output, time, model };
    };

    eventStrm.addEventListener("message", (event) => {
      if (event.data === '[DONE]') {
        eventStrm.close();
        this.setState({ modelOutput: [] });
        return;
      }

      const newEvent = JSON.parse(event.data).completion;
      const newCards = [createCard(newEvent, new Date().toLocaleString()), ...this.state.cardsAnthropic.slice(1)];

      this.setState({ cardsAnthropic: newCards });
    });

    eventStrm.addEventListener("error", console.log);
    // eslint-disable-next-line
    const cardRender = setInterval(() => {
      const { cardsAnthropic, cards } = this.state;

      if (!cardsAnthropic[0] || !cardsAnthropic[0].output.length) {
        return;
      }

      if (!cards[0] || (cards[0].time !== cardsAnthropic[0].time)) {
        cards.unshift(createCard());
      }

      const [firstOutput, ...restOfOutputs] = cardsAnthropic[0].output;
      const newCards = [createCard(cards[0].output.concat(firstOutput), cardsAnthropic[0].time), ...cards.slice(1)];
      const newCardsAnthropic = [createCard(restOfOutputs, cardsAnthropic[0].time), ...cardsAnthropic.slice(1)];

      this.setState({
        cards: newCards,
        cardsAnthropic: newCardsAnthropic
      });
    }, 10);
  }

  useOpenAI = () => {
    const baseURL = process.env.NODE_ENV === "development"
      ? "http://localhost:8000"
      : "https://interview-sandbox-production.up.railway.app";

    let codeInput = this.state.code;

    // Use the baseURL in the EventSource URL
    let evntSrtm = new EventSource(`${baseURL}/openai?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`);

    evntSrtm.addEventListener("message", (event) => {
      const { data } = event;

      if (data === '[DONE]') {
        evntSrtm.close();
        this.setState({ modelOutput: [] });
        return;
      }

      const parsedData = JSON.parse(data.startsWith('d') ? data.substring(6) : data);
      const textMode = this.state.mode === "text/plain";
      const newTextContent = textMode ? parsedData.choices[0].text : parsedData.choices[0].delta.content;

      if (data.startsWith('d')) {
        this.setState(prevState => ({
          cardsOpenAI: [
            {
              "time": new Date(parsedData.created * 1000).toLocaleString(),
              "output": [newTextContent],
              model: "openai"
            },
            ...prevState.cardsOpenAI
          ],
        }));
      } else {
        this.setState(prevState => ({
          cardsOpenAI: [
            {
              ...prevState.cardsOpenAI[0],
              output: prevState.cardsOpenAI[0].output.concat(newTextContent),
              "time": new Date(parsedData.created * 1000).toLocaleString()
            },
            ...prevState.cardsOpenAI.slice(1)
          ],
        }));
      }
    });

    evntSrtm.addEventListener("error", (error) => {
      // Prints the information about an error
      console.log(error);
    });

    let cardRender = setInterval(() => {
      const cardsOpenAIHead = this.state.cardsOpenAI[0];

      if (!cardsOpenAIHead) {
        return;
      }

      if (cardsOpenAIHead.output.length === 0) {
        clearInterval(cardRender);
        this.setState({ cardsOpenAI: [] });
        return;
      }

      const { output: code, time } = cardsOpenAIHead;
      const outputSnippet = code.slice(0, 1);
      const cardsOpenAIOutput = code.slice(1);

      // Ensure there's an initial card in `cards` state if none exists
      if (!this.state.cards[0] || (this.state.cards[0].time !== time && this.state.cards[0].time !== undefined)) {
        this.state.cards.unshift({ "output": [], "time": undefined, "model": undefined });
      }

      const updatedCards = [
        { "output": [...this.state.cards[0].output, ...outputSnippet], "time": time, model: "openai" },
        ...this.state.cards.slice(1)
      ];

      const updatedCardsOpenAI = [
        { "output": cardsOpenAIOutput, "time": time, model: "openai" },
        ...this.state.cardsOpenAI.slice(1)
      ];

      this.setState({
        cards: updatedCards,
        cardsOpenAI: updatedCardsOpenAI
      });
    }, 1);
  };

  closeCard(index) {
    if (index > -1) {
      const newCards = [...this.state.cards];
      newCards.splice(index, 1);
      this.setState({ cards: newCards });
    }
  }

  copyCard(index) {
    const cardCopy = this.state.cards[index].output.join("");
    navigator.clipboard.writeText(cardCopy);
    return (
      <div>
        <p>copied to clipboard</p>
      </div>
    );
  }

  mapCards() {
    const { cards } = this.state;
    const { darkMode } = this.props;

    const cardInfo = cards.map((card, index) => (
      <Card
        key={index}
        index={index}
        output={card.output}
        cardCreated={card.time}
        model={card.model}
        darkMode={darkMode}
        closeCard={this.closeCard}
        copyCard={this.copyCard}
      />
    ));

    return (
      <RemoveScroll className="poweredBy scroll">
        <p>
          {cardInfo}
        </p>
      </RemoveScroll>
    );
  }

  poweredBy() {
    if (this.state.cards.length && this.state.currlang !== " plntxt") {
      return <div>
        <div className="codex poweredBy neonText">Codex</div>
      </div>
    } else if (this.state.cards.length && this.state.currlang === " plntxt") {
      return <div>
        <div className="codex poweredBy neonText">GPT-3</div>
      </div>
    }
  };

  // The Judge0 API is used to evaluste the users code,
  // there are two steps to that. 1-A code submission (POST request) is
  // made, and the response is a token. Then that token is used in a GET
  // request to return the result of the code execution. I split this
  // between the runCode() and useToken functions.
  async runCode() {
    this.setState({ loading: true });
    const baseURL = process.env.NODE_ENV === "development"
      ? "http://localhost:8000"
      : "https://interview-sandbox-production.up.railway.app";

    const handleResponseData = (data) => {
      let sessionid2 = this.state.sessionid;
      this.setState({ history: Object.assign(this.state.history, { [sessionid2]: new Date().toLocaleString() }) });
      localStorage.setItem("history", JSON.stringify(this.state.history));
      localStorage.setItem("prevBoard", JSON.stringify(this.state.sessionid));

      if (data.stdout) {
        let evalOutput = data.stdout;
        let compileOutput = data.compile_output;
        let errOut = data.stderr;
        let time = data.time;
        let memory = data.memory;

        const updatedState = errOut == null
          ? { evalOutput: evalOutput, compileOutput: compileOutput, errOut: errOut, loading: false, time: time, memory: memory }
          : { evalOutput: evalOutput + errOut, compileOutput: compileOutput, loading: false };

        this.setState(updatedState);
        sessionStorage.setItem("evalOutput", evalOutput);
        sessionStorage.setItem("compileOutput", compileOutput);
        sessionStorage.setItem("errOut", errOut);

        const dbRef = ref(getDatabase());
        if (this.state.login === true) {
          update(child(dbRef, `interviews/${this.state.uid}/${this.state.sessionid}`), {
            user: "" + this.state.user.uid,
          });
        }
        update(child(dbRef, `interviews/${this.state.uid}/${this.state.sessionid}`), {
          evalOutput: "" + this.state.evalOutput,
          compileOutput: "" + this.state.compileOutput,
        });
      } else if (data.stdout == null) {
        let errOut = data.stderr;
        let time = data.time;
        let memory = data.memory;
        this.setState({
          evalOutput: errOut,
          loading: false,
          time: time,
          memory: memory,
          compileOutput: this.state.compileOutput
        });
      }
    }

    if (this.state.openAiToggle) this.useOpenAI();
    if (this.state.flanT5Toggle) this.useHuggingFace();
    if (this.state.anthropicToggle) this.useAnthropic();
    if (this.state.PaLMToggle) this.usePaLM();

    const judge0URL = `${baseURL}/judge0?language_id=${this.state.language_id}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(this.state.code)}`;

    try {
      const response = await fetch(judge0URL, {
        method: "GET",
        params: { base64_encoded: 'true', fields: '*' },
      });
      const data = await response.json();
      handleResponseData(data);
    } catch (err) {
      console.log(err);
    }
  }

  toggleExtend() {
    this.setState(prevState => ({ evalExtend: !prevState.evalExtend }));
  }


  toggleTimer() {
    this.setState(prevState => ({ timerExtend: !prevState.timerExtend }));
  }


  toggleWhiteboard() {
    const newWhiteboardExtendValue = !this.state.whiteboardExtend;

    this.setState({ whiteboardExtend: newWhiteboardExtendValue });
    sessionStorage.setItem("whiteboardExtend", newWhiteboardExtendValue.toString());
  }


  toggleOpenAI() {
    const newOpenAiToggleValue = !this.state.openAiToggle;

    this.setState({ openAiToggle: newOpenAiToggleValue });
    sessionStorage.setItem("openAiToggle", newOpenAiToggleValue.toString());
  }

  toggleCompletion() {
    const newCompletionToggleValue = !this.state.completionToggle;

    this.setState({ completionToggle: newCompletionToggleValue });
    sessionStorage.setItem("completionToggle", newCompletionToggleValue.toString());
  }

  toggleFlanT5() {
    const newFlanT5ToggleValue = !this.state.flanT5Toggle;

    this.setState({ flanT5Toggle: newFlanT5ToggleValue });
    sessionStorage.setItem("flanT5Toggle", newFlanT5ToggleValue.toString());
  }

  toggleAnthropic() {
    const newAnthropicToggleValue = !this.state.anthropicToggle;

    this.setState({ anthropicToggle: newAnthropicToggleValue });
    sessionStorage.setItem("anthropicToggle", newAnthropicToggleValue.toString());
  }

  togglePaLM() {
    const newPaLMToggleValue = !this.state.PaLMToggle;

    this.setState({ PaLMToggle: newPaLMToggleValue });
    sessionStorage.setItem("PaLMToggle", newPaLMToggleValue.toString());
  }

  toggleBorder() {
    const newBorderToggleValue = !this.state.borderToggle;

    this.setState({ borderToggle: newBorderToggleValue });
    sessionStorage.setItem("borderToggle", newBorderToggleValue.toString());
  }

  //Lets you select between JS, Python, Ruby
  toggleLanguage(id, key, mode) {
    // Shallow copy of the array/object from state using the key
    const temp = Array.isArray(this.state[key]) ? [...this.state[key]] : { ...this.state[key] };

    temp[id].selected = !temp[id].selected;
    const newMode = temp[id];
    const { mode: newModeMode, language_id, title } = newMode;

    this.setState({
      [key]: temp,
      mode: newModeMode,
      language_id,
      currlang: title,
    });

    // Assuming you want to store the modified object/array as a JSON string under the same key name
    sessionStorage.setItem(key, JSON.stringify(temp));
    sessionStorage.setItem("mode", newModeMode);
    sessionStorage.setItem("language_id", language_id.toString());
    sessionStorage.setItem("currlang", title);
  }

  //To keep track of where the cursor is currently
  changeCursorPos = () => {
    const { line, ch } = this.state.cursorPosition;
    this.codemirror.getCodeMirror().doc.setCursor(line, ch);
  };

  //This is where the code editor handles changes from user input
  onChange = (editor, data, value) => {
    const cm = this.codemirror;
    const doc = cm.getDoc();

    if (!data.origin) {
      this.setState({ charCoords: undefined });
      return;
    }

    const cursorPosition = {
      line: doc.getCursor().line,
      ch: doc.getCursor().ch
    };

    const suffix = cm.getRange(doc.getCursor(), {
      line: doc.lineCount(),
      ch: 0
    });

    const newState = {
      cursorPosition,
      suffix,
      code: value
    };

    if (this.state.completionToggle) {
      newState.codeSuggestion = "";
      clearTimeout(this.inputTimer);
      this.inputTimer = setTimeout(() => {
        this.aiCompletion();
      }, 1500);
    }

    this.setState(newState);

    const dbRef = ref(getDatabase());
    return update(child(dbRef, `interviews/${this.state.uid}/${this.state.sessionid}`), {
      content: value
    });
  };

  //Code snippet from Coding.js0

  whiteboardRender() {
    const whiteboardExtendFromState = this.state.whiteboardExtend;
    const whiteboardExtendFromSession = sessionStorage.getItem("whiteboardExtend") === "true";
    const borderToggleFromState = this.state.borderToggle;
    const borderToggleFromSession = sessionStorage.getItem("borderToggle") === "true";
    const darkMode = this.props.darkMode;

    if (whiteboardExtendFromState || whiteboardExtendFromSession) {
      let handleWrapperClass = "";

      if (borderToggleFromState || borderToggleFromSession) {
        handleWrapperClass = darkMode ? "borderOn-dark" : "borderOn";
      } else {
        handleWrapperClass = darkMode ? "handleToggle-dark" : "handleToggle";
      }

      return (
        <div>
          <Resizable
            handleWrapperClass={handleWrapperClass}
            enable={{ left: true }}
            minWidth="40vw"
            maxWidth="69vw"
          >
            <RemoveScroll>
              <iframe
                title="Witeboard"
                className="witeboard"
                src={this.state.witeboard}
              ></iframe>
            </RemoveScroll>
          </Resizable>
        </div>
      );
    }
  }

  login() {
    this.props.history.push("/login");
  };

  logout() {
    const auth = getAuth();
    signOut(auth).then(() => {
      // Sign-out successful.
      this.setState({
        login: false,
      })
    }).catch((error) => {
      // An error happened.
    });
  }

  loginRender() {
    const { login } = this.state;
    const iconStyle = {
      size: "1.35em",
      style: {
        paddingRight: "0.2rem",
        marginTop: "0.1rem",
        position: "fixed",
        top: "11px",
        right: "1%"
      }
    };

    return (
      <div
        title={login ? "logout" : "login"}
        onClick={login ? this.logout.bind(this) : this.login.bind(this)}
      >
        <IconContext.Provider value={iconStyle}>
          {login ? <CiLogout /> : <CiLogin />}
        </IconContext.Provider>
      </div>
    );
  }

  toolTipRender() {
    if (this.state.charCoords) {
      if (this.codemirror.getCodeMirror().doc.getAllMarks().length > 0) {
        return <div className="tooltip" style={{ top: this.codemirror.getCodeMirror().heightAtLine(this.state.cursorPosition.line) - 4.2, left: this.state.charCoords.left }}>
          <div className="tooltip-text">
            <div className="tooltip-shift-tab tooltip-text" onClick={this.acceptSuggestion.bind(this)}>
              SHIFT + TAB to Accept |
            </div>
            <div className="tooltip-escape tooltip-text" onClick={this.denySuggestion.bind(this)}>
              | ESC to Deny
            </div>
          </div>
        </div>
      }
    }
  }

  acceptSuggestion() {
    console.log("acceptSuggestion")
    const { line, ch } = this.state.cursorPosition;
    let codeSuggestionLength = this.state.codeSuggestion;
    this.codemirror.getCodeMirror().doc.getAllMarks().forEach(marker => marker.clear());
    this.codemirror.getCodeMirror().doc.setCursor(line, ch + codeSuggestionLength.length);

  }

  denySuggestion() {
    console.log("denySuggestion")
    const { line, ch } = this.state.cursorPosition;
    let codeSuggestionLength = this.state.codeSuggestion;
    this.setState({
      charCoords: undefined
    });
    this.codemirror.getCodeMirror().doc.replaceRange("", { line: line, ch: ch }, { line: line, ch: ch + codeSuggestionLength.length })

  }

  render() {
    initializeAnalytics();
    // eslint-disable-next-line  
    let usageStats = this.state.usage;
    // eslint-disable-next-line
    let codeSuggestion = this.state.code + this.state.codeSuggestion;
    const { line, ch } = this.state.cursorPosition;
    let codeSuggestionLength = this.state.codeSuggestion;
    return (
      <RemoveScroll>
        <React.Fragment>
          <Hotkeys
            keyName="command+enter,alt+s"
            onKeyDown={this.onKeyDown.bind(this)}
            onKeyUp={this.onKeyUp.bind(this)}
          >
            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" />
            <Header
              darkMode={this.props.darkMode}
              extras={
                <div className="createdOn">
                  {this.state.createdon
                    ? `${this.state.createdon}`
                    : ""}
                </div>
              }
            />
            {this.loginRender()}
            {this.toolTipRender()}
            <History history={this.state.history} />
            <div className={this.state.whiteboardExtend === false ? "topMost-whiteboard" : "topMost"}>
              <div className="coding">
                <div className="topHalf">
                  <div className={this.state.whiteboardExtend === false ? "coding-page" : "coding-page-whiteboard"}>
                    {/* This is where the CODE EDITOR goes */}
                    <CodeMirror
                      editorDidMount={editor => { this.codemirror = editor; }}
                      value={this.state.code}
                      onBeforeChange={(editor, data, value) => this.onChange(editor, data, value)}
                      options={{
                        theme: "dracula",
                        lineNumbers: true,
                        lineWrapping: true,
                        tabMode: "indent",
                        matchBrackets: true,
                        matchTags: true,
                        autoCloseTags: true,
                        autoCloseBrackets: true,
                        readOnly: false,
                        scrollbarStyle: "null",
                        mode: this.state.mode,
                        autofocus: true,
                        indentWithTabs: true,
                        smartIndent: true,
                        extraKeys: {
                          "Shift-Tab": (cm) => {
                            cm.doc.getAllMarks().forEach(marker => marker.clear());
                            cm.doc.setCursor(this.state.cursorPosition.line, this.state.cursorPosition.ch + this.state.codeSuggestion.length);
                          },
                          "Cmd-Enter": (cm) => { },
                          "Esc": (cm) => {
                            if (this.state.codeSuggestion) {
                              cm.doc.replaceRange("",
                                { line: this.state.cursorPosition.line, ch: this.state.cursorPosition.ch },
                                { line: this.state.cursorPosition.line, ch: this.state.cursorPosition.ch + this.state.codeSuggestion.length }
                              );
                            }
                          }
                        }
                      }}
                      className={this.props.darkMode === false ? "CodeMirror-theme code-mirror-container" : "CodeMirror-theme-dark code-mirror-container"}
                      style={{ backgroundColor: this.props.darkMode === false ? '#282a36' : '#000' }}
                    />
                    {/* This is where the DROPDOWN menu goes */}
                    <Dropdown
                      title="Language "
                      list={this.state.language}
                      toggleItem={this.toggleLanguage}
                      className="dropdown"
                      currLang={this.state.currlang}
                    />
                    <div className="aiCard">
                      {this.mapCards()}
                    </div>
                  </div>
                </div>
                <div className="lowerHalf">
                  <div className="lowerMenu evalSec">
                    {/* This is where the CODE EXECUTION happens */}
                    <Eval
                      code={this.state.code}
                      language_id={this.state.language_id}
                      sessionid={this.state.sessionid}
                      evalExtend={this.state.evalExtend}
                      timerExtend={this.state.timerExtend}
                      darkMode={this.props.darkMode}
                      toggleExtend={this.toggleExtend.bind(this)}
                      toggleTimer={this.toggleTimer.bind(this)}
                      toggleWhiteboard={this.toggleWhiteboard.bind(this)}
                      toggleOpenAI={this.toggleOpenAI.bind(this)}
                      openAiToggle={this.state.openAiToggle}
                      toggleCompletion={this.toggleCompletion.bind(this)}
                      completionToggle={this.state.completionToggle}
                      toggleFlanT5={this.toggleFlanT5.bind(this)}
                      flanT5Toggle={this.state.flanT5Toggle}
                      toggleBorder={this.toggleBorder.bind(this)}
                      borderToggle={this.state.borderToggle}
                      anthropicToggle={this.state.anthropicToggle}
                      PaLMToggle={this.state.PaLMToggle}
                      togglePaLM={this.togglePaLM.bind(this)}
                      toggleAnthropic={this.toggleAnthropic.bind(this)}
                      loading={this.state.loading}
                      token={this.state.token}
                      evalOutput={this.state.evalOutput}
                      compileOutput={this.state.compileOutput}
                      time={this.state.time}
                      memory={this.state.memory}
                      evalOutputDB={this.state.evalOutputDB}
                      runCode={this.runCode.bind(this)}
                      login={this.state.login}
                      whiteboardExtend={this.state.whiteboardExtend}
                    />
                  </div>
                  <div className="lowerMenu videoSec">
                    {/* This is where the VIDEO CHAT goes */}
                    {this.state.sessionid === null ? (
                      <div />
                    ) : (
                      <VideoChat whiteboardExtend={this.state.whiteboardExtend} sessionid={this.state.sessionid} />
                    )}
                  </div>
                </div>
              </div>
              {this.whiteboardRender()}
            </div>
          </Hotkeys>
        </React.Fragment>
      </RemoveScroll >
    );
  }
}

// WEBPACK FOOTER //
// ./src/containers/pages/Coding.js
